var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoticeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C1D354"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DB138"
    },
    d: "M333.862,139.333c-0.074-0.108-0.146-0.182-0.259-0.294c-0.108-0.108-0.182-0.182-0.289-0.253 c-1.94-1.797-4.352-2.675-6.802-2.675c-2.56,0-5.12,0.998-7.058,2.929c-1.974,1.974-2.964,4.536-2.964,7.094 c-18.245,24.32-47.357,40.09-80.125,40.09h-23.956l-2.522-2.522h-65.098c-8.069,0-16.097,2.788-22.607,8.294l-0.028-0.028 c-0.732,0.617-1.464,1.313-2.161,2.002c-6.874,6.848-10.278,15.839-10.278,24.806v30.052c0,1.075,0.056,2.148,0.156,3.223 c0.031,0.343,0.092,0.689,0.133,1.024c0.092,0.732,0.182,1.454,0.315,2.179c0.074,0.399,0.177,0.801,0.261,1.193 c0.148,0.66,0.294,1.321,0.479,1.966c0.12,0.422,0.261,0.835,0.402,1.249c0.197,0.625,0.407,1.234,0.64,1.846 c0.164,0.43,0.351,0.85,0.532,1.28c0.246,0.568,0.509,1.137,0.794,1.705c0.218,0.443,0.453,0.878,0.694,1.316 c0.282,0.512,0.584,1.011,0.893,1.503c0.294,0.484,0.599,0.963,0.927,1.426c0.274,0.399,0.568,0.788,0.863,1.18 c0.42,0.548,0.845,1.088,1.295,1.615c0.061,0.077,0.115,0.156,0.179,0.225l0.264,0.274c0.481,0.533,0.937,1.08,1.454,1.592 c0.492,0.499,1.019,0.934,1.531,1.385l0.445,0.451l45.64,45.635l0.01,0.008l13.775,49.654c0.328,1.242,1.021,2.383,2.012,3.295 c0.069,0.036,0.113,0.069,0.148,0.148l131.008,131.003c95.393-22.341,170.212-97.979,191.36-193.818L333.862,139.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CEE2F2"
    },
    d: "M181.399,370.737c0.479,1.728,1.618,3.279,3.305,4.227c1.684,0.963,3.592,1.137,5.327,0.653 l24.778-6.881c1.736-0.479,3.274-1.608,4.229-3.3c0.955-1.679,1.129-3.597,0.655-5.325l-24.105-86.848l-38.295,10.619 L181.399,370.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F9FF"
    },
    d: "M194.45,374.387l-4.421,1.229c-0.906,0.246-1.866,0.323-2.806,0.189l-25.828-93.069l7.091-1.953 L194.45,374.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283A4D"
    },
    d: "M210.627,327.452l1.352-0.374c1.708-0.471,3.267-1.615,4.221-3.292 c0.942-1.679,1.116-3.597,0.645-5.317l-1.874-6.756c-0.484-1.715-1.615-3.246-3.292-4.201c-1.682-0.963-3.599-1.137-5.32-0.66 l-1.341,0.374L210.627,327.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D6D7E"
    },
    d: "M350.144,233.843c0,20.646-16.747,37.376-37.394,37.376c-20.631,0-37.386-16.73-37.386-37.376 c0-20.649,16.758-37.399,37.386-37.399C333.396,196.444,350.144,213.194,350.144,233.843z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 357.376,
    y: 231.424,
    style: {
      fill: "#FFFFFF"
    },
    width: 44.913,
    height: 4.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.106,
    y: 193.467,
    transform: "matrix(-0.7072 0.707 -0.707 -0.7072 772.8123 71.7022)",
    style: {
      fill: "#FFFFFF"
    },
    width: 44.907,
    height: 4.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.095,
    y: 269.414,
    transform: "matrix(-0.7071 -0.7072 0.7072 -0.7071 442.0406 726.769)",
    style: {
      fill: "#FFFFFF"
    },
    width: 44.918,
    height: 4.823
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1EFFA"
    },
    d: "M236.365,186.212h-26.476v95.171h26.476c32.773,0,61.873,15.736,80.141,40.064V146.132 C298.237,170.465,269.138,186.212,236.365,186.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M236.365,209.206h-26.476V193.18h26.476c32.773,0,61.873-15.747,80.141-40.074v16.026 C298.237,193.467,269.138,209.206,236.365,209.206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283A4D"
    },
    d: "M336.54,321.446c0,2.565-0.978,5.128-2.934,7.081c-1.961,1.961-4.523,2.934-7.086,2.934l0,0 c-2.565,0-5.128-0.975-7.084-2.934c-1.958-1.953-2.934-4.516-2.934-7.081V146.132c0-2.557,0.975-5.12,2.934-7.086 c1.956-1.946,4.518-2.929,7.084-2.929l0,0c2.563,0,5.125,0.983,7.086,2.929c1.958,1.966,2.934,4.531,2.934,7.086V321.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8E31"
    },
    d: "M209.889,283.884h-65.114c-8.975,0-17.943-3.42-24.796-10.268 c-6.845-6.851-10.266-15.823-10.266-24.799v-30.052c0-8.975,3.42-17.943,10.266-24.791c6.851-6.848,15.818-10.268,24.796-10.268 h65.116v100.178H209.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC74E"
    },
    d: "M120.113,217.935c-0.2,0-0.397-0.013-0.599-0.056c-1.915-0.33-3.19-2.148-2.86-4.052 c1.009-5.793,3.75-11.069,7.931-15.252c5.394-5.386,12.564-8.358,20.191-8.358h22.538c1.938,0,3.512,1.567,3.512,3.512 c0,1.93-1.574,3.505-3.512,3.505h-22.538c-5.757,0-11.164,2.24-15.227,6.305c-3.159,3.154-5.225,7.13-5.988,11.489 C123.261,216.735,121.782,217.935,120.113,217.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283A4D"
    },
    d: "M109.714,248.817h1.999c1.288,0,2.565-0.484,3.543-1.459c0.975-0.983,1.469-2.268,1.469-3.548V223.78 c0-1.285-0.492-2.57-1.469-3.548c-0.978-0.978-2.253-1.467-3.543-1.467h-1.999V248.817z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeIcon);
export default __webpack_public_path__ + "static/media/noticeIcon.5c65bc44bbcd3c38ed6b45d1af33f600.svg";
export { ForwardRef as ReactComponent };